/* Auto-slide pattern identique a ol-press.js :
   sequence toutes les 3s, mouvement anime 700ms easing, boucle sans couture (clones), pause hover. */

(function () {
  'use strict';

  const sections = document.querySelectorAll('.ol-priv-galerie');
  if (!sections.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const INTERVAL_MS = 3000;
  const ANIM_MS = 700;

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  sections.forEach(function (section) {
    const track = section.querySelector('[data-priv-galerie-track]');
    if (!track || reduceMotion) return;

    const originals = Array.from(track.children);
    if (!originals.length) return;
    originals.forEach(function (node) {
      const clone = node.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    let loopDistance = 0;
    function measure() {
      const firstClone = track.children[originals.length];
      loopDistance = firstClone ? firstClone.offsetLeft - track.children[0].offsetLeft : 0;
    }
    measure();
    window.addEventListener('resize', measure);

    let pos = 0;
    let animating = false;

    function metrics() {
      const card = track.querySelector('.ol-priv-galerie__item');
      const cardWidth = card ? card.getBoundingClientRect().width : 0;
      const gap = parseFloat(getComputedStyle(track).gap) || 40;
      return cardWidth + gap;
    }

    function step() {
      if (animating) return;
      const from = pos;
      const to = from + metrics();
      const start = performance.now();
      animating = true;

      function frame(now) {
        const t = Math.min(1, (now - start) / ANIM_MS);
        pos = from + (to - from) * easeInOutCubic(t);
        track.scrollLeft = pos;
        if (t < 1) {
          requestAnimationFrame(frame);
        } else {
          pos = to;
          if (loopDistance && pos >= loopDistance) {
            pos -= loopDistance;
            track.scrollLeft = pos;
          }
          animating = false;
        }
      }
      requestAnimationFrame(frame);
    }

    let timer = setInterval(step, INTERVAL_MS);
    function pause() { clearInterval(timer); timer = null; }
    function resume() { if (!timer) timer = setInterval(step, INTERVAL_MS); }

    track.addEventListener('mouseenter', pause);
    track.addEventListener('mouseleave', resume);
    track.addEventListener('focusin', pause);
    track.addEventListener('focusout', resume);
  });
})();
